<template>
  <div class="growthStageManagement-page">
    <h3>
      {{ growthModelName }}
    </h3>
    <el-tabs v-model="activeName">
      <el-tab-pane label="单一条件自动调节参数配置" name="first">
        <div class="all-content-container">
          <div class="growth-title-container">
            <div class="table-title-btn">
              <el-button type="primary" style="margin-left: 10px" @click="handleImport">导入</el-button>
              <el-button type="primary" @click="handleExport">导出</el-button>
              <!-- <el-button type="primary" @click="handleExport">模板下载</el-button> -->
              <el-button type="primary" @click="handleSave">保存</el-button>
              <el-button type="primary" @click="handleReturn">返回</el-button>
            </div>
          </div>
          <div class="growth-table-container" v-for="(item, index) in tableDataList" :key="index">
            <div class="table-title-container">
              <h4>{{ item.stageName }}</h4>
              <el-image style="
              height: 40px;
              width: 50px;
              margin-left: 20px;
              margin-top: 5px;
            " :src="item.image" :preview-src-list="[item.image]" fit="fill">
              </el-image>
              <span class="stage-span" @click="handleDelStage(index)">删除</span>
              <span class="stage-span" @click="handleEditStage(index)">编辑</span>
            </div>
            <div class="table-content-container">
              <div class="table-content-title">
                <div v-for="(item2, index2) in item.timeList" :key="index2" style="display: inline-block">
                  <el-button :class="{ current_button: index2 == item.stageTimeTab }" style="margin-right: 15px" plain @click="handleSeeData(index, index2)">{{ item2.timeName + '（' + (item2.cycleTime == undefined || item2.cycleTime == null ? 0 : item2.cycleTime) + '天）' }}</el-button>
                </div>
                <span class="time-span" @click="handleAddTime(index)">添加细分阶段</span>
                <span class="time-span" @click="handleEditTime(index)" v-if="item.stageTimeTab > -1">编辑</span>
                <span class="time-span" @click="handleDelTime(index)" v-if="item.stageTimeTab > -1">删除</span>
                <el-button type="primary" style="float: right; margin-right: 10px;}" v-if="item.stageTimeTab > -1" @click="handleAddData(index)">+添加时间段</el-button>
                <el-button type="primary" style="float: right; margin-right: 10px;}" v-if="item.stageTimeTab > -1" @click="handleAddColumn(index)">+添加环境参数</el-button>
              </div>
              <div class="table-content">
                <el-table v-if="item.timeList.length > 0" :data="item.stageTimeTab > -1 ? item.timeList[item.stageTimeTab].dataList : []" style="width: 150%" :header-cell-style="{ background: '#f4f5f7' }">
                  <el-table-column fixed label="时间段" min-width="240" prop="timeFrame" align="center">
                    <template slot-scope="scope">
                      <el-time-picker v-if="scope.row.time ? true : false" is-range v-model="scope.row.time" range-separator="~" start-placeholder="开始" end-placeholder="结束" value-format="HH:mm" format="HH:mm" :picker-options="{
                          start: '00:00',
                          step: '00:01',
                          end: '23:29'
                        }" @change="timeChange(index, item.stageTimeTab, scope.$index)">
                      </el-time-picker>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="250" align="center" v-for="(item3, index3) in item.timeList[item.stageTimeTab].timeAttributes" :key="index3">
                    <template slot="header">
                      <el-popover placement="top">
                        <div style="text-align: center">
                          <el-button type="primary" plain @click="handleAddColumn(index, item3)">编辑</el-button>
                          <el-button type="danger" plain @click="handleDelColumn(index, item.stageTimeTab, index3)">删除</el-button>

                          <!-- <el-button
                      type="reference"
                      @click="handleMoveLeftColumn(index, item.stageTimeTab, index3)"
                      >左移</el-button
                    >
                    <el-button
                      type="reference"
                      @click="handleMoveRightColumn(index, item.stageTimeTab, index3)"
                      >右移</el-button
                    > -->
                        </div>
                        <el-button slot="reference">{{ dealAttribute(item3.growthModelAttributeName, item3.growthModelAttributeUnit) }}{{ item3.difStart }}-{{ item3.difEnd }}</el-button>
                      </el-popover>
                    </template>
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.attributeValues[index3].minValue" controls-position="right" :min="0" :max="scope.row.attributeValues[index3].maxValue" :precision="2" size="mini" placeholder="最小" align="center" style="width: 48%; margin-right: 2px"></el-input-number>
                      <el-input-number v-model="scope.row.attributeValues[index3].maxValue" controls-position="right" :min="scope.row.attributeValues[index3].minValue" :max="99999999" :precision="2" size="mini" placeholder="最大" align="center" style="width: 48%; margin-left: 2px"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" align="center" width="100">
                    <template slot-scope="scope">
                      <el-button @click="handleDelData(index, scope)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <el-button type="primary" style="margin-bottom: 200px; margin-top: 50px" @click="handleAddStage">+添加生长阶段</el-button>
          <el-dialog title="导入模板" :visible.sync="importDialog" width="500px" :before-close="handleCloseImport">
            <div class="equipmentcenter-opption-box">
              <el-form ref="importForm" label-width="0px">
                <el-form-item label="" style="width: 100%">
                  <el-upload class="upload-demo" :action="$serverUrl + '/pc/growthModelDetail/importExcel'" :data="{ modelId: growthModelId }" :headers="headers" name="file" :before-upload="handleChange" :on-success="handleAvatarSuccess" :limit="1" :file-list="importFileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">
                      只能上传excel（.xls和.xlsx）文件
                    </div>
                  </el-upload>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog :title="addEditStageTitle" :visible.sync="addEditStageIsDialog" width="600px" center style="z-index: 10000">
            <div class="info-content-container info-content-container-add">
              <el-form :inline="true" :model="stageForm" :rules="stageRules" ref="stageForm" class="demo-form-inline">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="阶段图片：" prop="image">
                      <el-upload class="avatar-uploader" :action="$serverUrl + '/pc/growthCrop/uploadImage'" :headers="headers" name="file" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                        <img v-if="stageForm.image != undefined && stageForm.image != ''" :src="stageForm.image" style="width: 100px; height: 100px" />
                        <div v-else style="width: 100px; height: 100px">
                          <i class="avatar-uploader-icon">
                            <i class="el-icon-plus"></i>
                          </i>
                        </div>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="阶段名称：" prop="name">
                      <el-input v-model="stageForm.name" placeholder="请输入阶段名称" clearable maxlength="20" show-word-limit style="width: 400px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handleCloseStage">取 消</el-button>
              <el-button type="primary" @click="handleSaveStage">
                <a downloa style="color: #fff">确 定</a>
              </el-button>
            </span>
          </el-dialog>
          <el-dialog :title="addEditTimeTitle" :visible.sync="addEditTimeIsDialog" width="600px" center style="z-index: 10000">
            <div class="info-content-container info-content-container-add">
              <el-form :inline="true" :model="timeForm" :rules="timeRules" ref="timeForm" class="demo-form-inline" label-width="120px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="细分阶段名称：" prop="name">
                      <el-input v-model="timeForm.name" placeholder="请输入细分阶段名称" clearable maxlength="20" show-word-limit style="width: 350px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="周期天数：" prop="cycleTime">
                      <el-input-number v-model="timeForm.cycleTime" placeholder="请输入周期天数" :min="0" :max="9999" size="small" clearable style="width: 350px"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row>
              <el-col :span="24">
                <el-form-item label="光合作用模型：" prop="planIdArr">
                  <el-select v-model="timeForm.planIdArr" placeholder="请选择光合作用模型" multiple collapse-tags clearable style="width: 350px">
                    <el-option v-for="item in planArray" :key="item.id + ''" :label="item.planName" :value="item.id + ''"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row> -->
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="排序号：" prop="orderNum">
                      <el-input-number v-model="timeForm.orderNum" placeholder="请输入排序号" :min="0" :max="9999" size="small" clearable style="width: 350px"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handleCloseTime">取 消</el-button>
              <el-button type="primary" @click="handleSaveTime">
                <a downloa style="color: #fff">确 定</a>
              </el-button>
            </span>
          </el-dialog>
          <el-dialog :title="addEditColumnTitle" :visible.sync="addEditColumnIsDialog" width="600px" center style="z-index: 10000">
            <div class="info-content-container info-content-container-add">
              <el-form :inline="true" :model="columnForm" :rules="columnRules" ref="columnForm" class="demo-form-inline" label-width="120px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="环境字段：" prop="growthModelAttributeId">
                      <el-select v-model="columnForm.growthModelAttributeId" placeholder="请选择环境字段" clearable style="width: 350px">
                        <el-option v-for="item in growthModelAttributeArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="下限回差：" prop="difStart">
                      <el-input v-model="columnForm.difStart" placeholder="请输入下限回差"></el-input>
                    </el-form-item>
                    <el-form-item label="上限回差：" prop="difEnd">
                      <el-input v-model="columnForm.difEnd" placeholder="请输入上限回差"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handleCloseColumn">取 消</el-button>
              <el-button type="primary" @click="handleSaveColumn">
                <a downloa style="color: #fff">确 定</a>
              </el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
      <el-tab-pane label="多条件自动调节参数配置" name="second">
        <div v-if="timeShow" class="growth-table-container" v-for="(item, index) in tableDataList" :key="index">
          <div class="table-title-container">
            <h4>{{ item.stageName }}</h4>
            <el-image style="
              height: 40px;
              width: 50px;
              margin-left: 20px;
              margin-top: 5px;
            " :src="item.image" :preview-src-list="[item.image]" fit="fill">
            </el-image>
            <!-- <span class="stage-span" @click="handleDelStage(index)">删除</span>
            <span class="stage-span" @click="handleEditStage(index)">编辑</span> -->
          </div>
          <div class="table-content-container">
            <div class="table-content-title">
              <div v-for="(item2, index2) in item.timeList" :key="index2" style="display: inline-block">
                <el-button :class="{ current_button: index2 == item.stageTimeTab }" style="margin-right: 15px" plain @click="handleSeeData(index, index2)">{{ item2.timeName + '（' + (item2.cycleTime == undefined || item2.cycleTime == null ? 0 : item2.cycleTime) + '天）' }}</el-button>
              </div>
              <!-- <span class="time-span" @click="handleAddTime(index)">添加</span>
              <span class="time-span" @click="handleEditTime(index)" v-if="item.stageTimeTab > -1">编辑</span>
              <span class="time-span" @click="handleDelTime(index)" v-if="item.stageTimeTab > -1">删除</span>
              <el-button type="primary" style="float: right; margin-right: 10px;}" v-if="item.stageTimeTab > -1" @click="handleAddData(index)">+添加参数</el-button>
              <el-button type="primary" style="float: right; margin-right: 10px;}" v-if="item.stageTimeTab > -1" @click="handleAddColumn(index)">+添加字段</el-button> -->
            </div>
            <div v-if="item.timeList.length > 0" class="table-content">
              <el-tabs v-model="item.timeList[item.stageTimeTab].timeIds" @tab-click="val => handleClick(val, index)">
                <el-button type="primary" style="margin-left:15px;margin-bottom:10px" @click="handleAddColumn_(item.timeList[item.stageTimeTab].activeName_, item.timeList[item.stageTimeTab])">添加环境参数</el-button>
                <el-table :data="item.timeList[0].tableData_" style="width: 150%" :header-cell-style="{ background: '#f4f5f7' }">
                  <el-table-column prop="growthModelAttributeName" align="center" label="环境参数" width></el-table-column>
                  <el-table-column align="center" label="自动控制权重" width>
                    <template slot-scope="scope">
                      <!-- <el-button >定时任务详情</el-button> -->
                      <span>{{ scope.row.weight }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="自动控制详情" width>
                    <!-- <el-button >定时任务详情</el-button> -->
                    <span>详情见单一条件自动调节参数</span>
                  </el-table-column>
                  <el-table-column align="center" label="定时任务权重" width>
                    <template slot-scope="scope">
                      <!-- <el-button >定时任务详情</el-button> -->
                      <span>{{ scope.row.taskWeight }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="定时任务详情" align="center" width="150">
                    <template slot-scope="scope">
                      <el-button @click="openAddit(scope.row)" type="text" size="small">定时任务详情</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column prop="intervalDay" align="center" label="间隔天数" width></el-table-column>

                  <!-- <el-table-column prop="lowerValue" align="center" label="下限值" width></el-table-column>
                  <el-table-column prop="difEnd" align="center" label="下限回差" width></el-table-column>
                  <el-table-column prop="upValue" align="center" label="上限值" width></el-table-column>
                  <el-table-column prop="difStart" align="center" label="上限回差" width></el-table-column> -->
                  <el-table-column prop="bias" align="center" label="偏置系数" width></el-table-column>

                  <el-table-column fixed="right" label="操作" align="center" width="260">
                    <template slot-scope="scope">
                      <!-- <el-button @click="openAddit(scope.row)" type="text" size="small">定时任务</el-button> -->

                      <el-button @click="getGrowthModelTimeAttributeValueConfig(scope)" type="text" size="small">编辑</el-button>
                      <el-button style="color:red" @click="handleDelData_(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tabs>
            </div>
          </div>
        </div>

        <el-dialog :title="`${ruleFormTime.name}定时任务`" :visible.sync="timedTaskDialog" width="1100px" center style="z-index: 10000">
          <div class="a23">
            <div>
              <el-button type="primary" size="small" @click="openAddit_">新增配置</el-button>
            </div>
            <div>
              <!-- <el-button type="primary" size="small">定时任务下发</el-button> -->
              <!-- 
              <el-button type="primary" size="small" v-if="activeName==1" @click="handleSaveExtend_A(activeName)">滴灌定时任务下发</el-button>
              <el-button type="primary" size="small" v-if="activeName==2" @click="handleSaveExtend_A(activeName)">外风机定时任务下发</el-button>
              <el-button type="primary" size="small" v-if="activeName==3" @click="handleSaveExtend_A(activeName)">内风机定时任务下发</el-button> -->
              <!-- <el-button type="primary" size="small" @click="openTimeTask_1">下发记录查询</el-button> -->
            </div>
          </div>

          <div class="table_content1" style="margin-top: 10px">
            <el-table :data="tableData_" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
              <el-table-column type="index" width="50"> </el-table-column>
              <el-table-column prop="startTime" align="center" label="开始时间" width></el-table-column>
              <el-table-column prop="endTime" align="center" label="结束时间" width></el-table-column>
              <!-- <el-table-column prop="endValue" align="center" label="下限值" width></el-table-column>
              <el-table-column prop="difEnd" align="center" label="下限回差" width></el-table-column>
              <el-table-column prop="startValue" align="center" label="上限值" width></el-table-column>
              <el-table-column prop="difStart" align="center" label="上限回差" width></el-table-column> -->
              <!-- <el-table-column prop="intervalDay" align="center" label="间隔天数" width></el-table-column> -->
              <!-- <el-table-column v-if=" ruleFormTime.name.includes('温度')||ruleFormTime.name.includes('湿度')" prop="startValue" align="center" label="开始值" width></el-table-column>
              <el-table-column v-if=" ruleFormTime.name.includes('温度')||ruleFormTime.name.includes('湿度')" prop="endValue" align="center" label="结束值" width></el-table-column>
              <el-table-column v-if=" ruleFormTime.name.includes('温度')||ruleFormTime.name.includes('湿度')" prop="difStart" align="center" label="开始回差" width></el-table-column>
              <el-table-column v-if=" ruleFormTime.name.includes('温度')||ruleFormTime.name.includes('湿度')" prop="difEnd" align="center" label="结束回差" width></el-table-column> -->

              <el-table-column align="center" label="启用状态" width>
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">已禁用</span>
                  <span v-if="scope.row.status == 1">已启用</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="操作" width="260">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.status == 0" @click="updateGrowthModelDecisionScheduleStatus(scope.row.id)" type="text" size="small">启用</el-button>
                  <el-button style="color:red" v-if="scope.row.status == 1" @click="updateGrowthModelDecisionScheduleStatus(scope.row.id)" type="text" size="small">禁用</el-button>
                  <el-button @click="updatabox(scope.row.id)" type="text" size="small">编辑</el-button>
                  <el-button style="color:red" type="text" size="small" @click="delGrowthModelTimeAttributeValueConfigTask(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="dialog-footer">
            <!-- <el-button @click="handleCancelExtend1">取 消</el-button> -->
          </div>
        </el-dialog>
        <el-dialog title="定时任务配置" :visible.sync="extendIsDialog_" width="600px" center style="z-index: 10000">
          <el-form ref="ruleFormExtend" :rules="rulesExtend" :model="ruleFormTime" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="定时范围：" prop="time">
                  <el-time-picker is-range v-model="ruleFormTime.time" range-separator="至" start-placeholder="开启时间" value-format="HH:mm" format="HH:mm" end-placeholder="关闭时间" placeholder="选择时间范围"> </el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="24">
                <el-form-item label="下限值：" prop="endValue">
                  <el-input v-model="ruleFormTime.endValue" placeholder="请输入下限值"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="下限回差：" prop="difEnd">
                  <el-input v-model="ruleFormTime.difEnd" placeholder="请输入下限回差"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上限值：" prop="startValue">
                  <el-input v-model="ruleFormTime.startValue" placeholder="请输入上限值"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上限回差：" prop="difStart">
                  <el-input v-model="ruleFormTime.difStart" placeholder="请输入上限回差"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
            <!-- <el-row>
              <el-col :span="24">
                <el-form-item label="开始回差：" prop="difStart">
                  <el-input v-model="ruleFormTime.difStart" placeholder="请输入开始回差"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="ruleFormTime.name.includes('温度')||ruleFormTime.name.includes('湿度')">
              <el-col :span="24">
                <el-form-item label="结束回差：" prop="difEnd">
                  <el-input v-model="ruleFormTime.difEnd" placeholder="请输入结束回差"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="ruleFormTime.name.includes('温度')||ruleFormTime.name.includes('湿度')">
              <el-col :span="24">
                <el-form-item label="开始值：" prop="startValue">
                  <el-input v-model="ruleFormTime.startValue" placeholder="请输入开始值"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="ruleFormTime.name.includes('温度')||ruleFormTime.name.includes('湿度')">
              <el-col :span="24">
                <el-form-item label="结束值：" prop="endValue">
                  <el-input v-model="ruleFormTime.endValue" placeholder="请输入结束值"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancelExtend">取 消</el-button>
            <el-button type="primary" @click="handleSaveExtend_Time">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="addEditColumnTitle" :visible.sync="addEditColumnIsDialog_" width="600px" center style="z-index: 10000">
          <div class="info-content-container info-content-container-add">
            <el-form :inline="true" :model="columnForm" :rules="columnRules" ref="columnForm" class="demo-form-inline" label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="环境参数：" prop="growthModelAttributeId">
                    <el-select v-model="columnForm.growthModelAttributeId" placeholder="请选择环境参数" clearable style="width: 350px">
                      <el-option v-for="item in growthModelAttributeArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-form-item label="自动控制权重" prop="weight">
                  <el-input-number v-model="columnForm.weight" :min="0" :max="100" label="自动控制权重"></el-input-number>
                </el-form-item>
                <el-form-item label="偏置系数：" prop="bias">
                  <el-input v-model="columnForm.bias" placeholder="请输入偏置系数"></el-input>
                </el-form-item>

                <el-form-item label="定时任务权重：" prop="weight">
                  <el-input-number :disabled="true" :value="100 - columnForm.weight" :min="0" :max="100" label="定时任务权重"></el-input-number>
                </el-form-item>
                <el-col :span="24">
                  <el-form-item label="间隔天数：">
                    <el-input-number size="small" v-model="columnForm.intervalDay" :min="0" :max="100" label="间隔天数"></el-input-number>
                  </el-form-item>
                </el-col>
                <!-- <el-form-item label="下限值：" prop="lowerValue">
                    <el-input v-model="columnForm.lowerValue" placeholder="请输入下限值"></el-input>
                  </el-form-item>
                  <el-form-item label="下限回差：" prop="difEnd">
                    <el-input v-model="columnForm.difEnd" placeholder="请输入下限回差"></el-input>
                  </el-form-item>
                  <el-form-item label="上限值：" prop="upValue">
                    <el-input v-model="columnForm.upValue" placeholder="请输入上限值"></el-input>
                  </el-form-item>
                  <el-form-item label="上限回差：" prop="difStart">
                    <el-input v-model="columnForm.difStart" placeholder="请输入上限回差"></el-input>
                  </el-form-item> -->
              </el-row>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseColumn_">取 消</el-button>
            <el-button type="primary" @click="handleSaveColumn_">
              <a downloa style="color: #fff">确 定</a>
            </el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first',
      activeName_: '',
      headers: {
        // 请求头
        AUTHORIZATION: sessionStorage.getItem('TOKEN')
      },
      tableDataList: [], // 生长模型数据模型，阶段-时间-数据
      growthModelId: '', // 生长模型ID
      growthModelName: '', // 生长模型名称
      stageForm: {
        // 生长阶段表单
        name: '',
        image: ''
      },
      timedTaskDialog: false,

      stageRules: {
        // 生长阶段表单规则
        image: [
          {
            required: true,
            message: '请上传阶段图片',
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入阶段名称',
            trigger: 'blur'
          }
        ]
      },
      addEditStageTitle: '添加生长阶段', // 添加编辑生长阶段弹窗标题
      addEditStageIndex: 0, // 添加编辑生长阶段弹窗index
      addEditStageIsDialog: false, // 添加编辑生长阶段弹窗是否显示
      timeForm: {
        // 生长时间表单
        name: '',
        cycleTime: '',
        planIdArr: [],
        planIds: '',
        orderNum: ''
      },
      timeRules: {
        // 生长时间表单规则
        name: [
          {
            required: true,
            message: '请输入细分阶段名称',
            trigger: 'blur'
          }
        ],
        cycleTime: [
          {
            required: true,
            message: '请输入周期天数',
            trigger: 'blur'
          }
        ],
        planIdArr: [
          {
            required: false,
            message: '请选择光合作用模型',
            trigger: 'change'
          }
        ],
        orderNum: [
          {
            required: true,
            message: '请输入排序号',
            trigger: 'blur'
          }
        ]
      },
      addEditTimeTitle: '添加细分阶段', // 添加编辑生长时间弹窗标题
      addEditTimeIndex: 0, // 添加编辑生长时间弹窗index
      addEditTimeIsDialog: false, // 添加编辑生长时间弹窗是否显示

      columnForm: {
        // 字段表单
        growthModelAttributeId: '',
        difStart: '',
        difEnd: '',
        bias: '',
        lowerValue: '',
        modelTimeAttributeValueId: '',
        upValue: '',
        weight: '',
        taskWeight: '',
        intervalDay: ''
      },
      columnRules: {
        // 字段表单规则
        growthModelAttributeId: [
          {
            required: true,
            message: '请选择环境字段',
            trigger: 'change'
          }
        ],
        intervalDay: [
          {
            required: true,
            message: '请输入间隔天数',
            trigger: 'blur'
          }
        ],
        difStart: [
          {
            required: true,
            message: '请输入开始回差',
            trigger: 'blur'
          }
        ],
        difEnd: [
          {
            required: true,
            message: '请输入结束回差',
            trigger: 'blur'
          }
        ],
        lowerValue: [
          {
            required: true,
            message: '请输入下限值',
            trigger: 'blur'
          }
        ],
        upValue: [
          {
            required: true,
            message: '请输入上限值',
            trigger: 'blur'
          }
        ],
        bias: [
          {
            required: true,
            message: '请输入偏置',
            trigger: 'blur'
          }
        ],
        weight: [
          {
            required: true,
            message: '请输入权重',
            trigger: 'blur'
          }
        ]
      },
      addEditColumnTitle: '添加环境参数', // 添加编辑生长时间字段弹窗标题
      addEditColumnIndex: 0, // 添加编辑生长时间弹窗index
      addEditColumnIsDialog: false, // 添加编辑生长时间字段弹窗是否显示
      addEditColumnIsDialog_: false,
      importDialog: false, // 导入弹窗是否显示
      importFileList: [], // 导入文件列表数组
      planArray: [], // 光合作用数组
      growthModelAttributeArray: [], // 生长模型字段属性数组
      showRule: false,
      timeShow: false,
      tableList: [],
      extendIsDialog_: false,
      tableData_: [],
      ruleFormTime: {
        endTime: '',
        intervalDay: '',
        startTime: '',
        modelTimeAttributeValueConfigId: '',
        id: '',
        difEnd: '',
        difStart: '',
        endValue: '',
        startValue: '',
        name: ''
      }
    }
  },
  watch: {
    tableDataList: {
      handler(newValue, oldVal) {
        console.log(this.showRule, 9999)
        // if (this.showRule) {
        //   this.showRule = false
        //   console.log(this.showRule, 668)
        //   // console.log(newValue, oldVal, 659)
        // }
      },
      deep: true // 深度监听
    }
  },
  created() {
    this.growthModelId = this.$route.query.growthModelId
    this.growthModelName = this.$route.query.growthModelName

    // 获取生长模型数据
    this.getGrowthModelData()

    // 获取光合作用模型列表
    this.getPlanAll()

    // 获取生长模型字段属性列表
    this.getGrowthModelAttributeList()
  },
  methods: {
    updateGrowthModelDecisionScheduleStatus(row) {
      this.$api.growthModel.updateGrowthModelTimeAttributeValueConfigTaskStatus({ id: row }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getGrowthModelTimeAttributeValueConfigTaskList()
        }
      })
    },
    updatabox(row) {
      this.addEditId = row
      this.ruleFormTime.id = row
      this.extendIsDialog_ = true
      this.getGrowthModelTimeAttributeValueConfigTask(row)
    },

    handleSaveExtend_Time() {
      this.$refs['ruleFormExtend'].validate(valid => {
        if (valid) {
          this.ruleFormTime.startTime = this.ruleFormTime.time[0]
          this.ruleFormTime.endTime = this.ruleFormTime.time[1]
          this.$api.growthModel.saveGrowthModelTimeAttributeValueConfigTask(this.ruleFormTime).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancelExtend()
              this.getGrowthModelTimeAttributeValueConfigTaskList()
            }
          })
        }
      })
    },
    // 取消
    handleCancelExtend() {
      this.$refs['ruleFormExtend'].resetFields()
      this.ruleFormExtend = {
        decisionId: this.addEditId,
        num: ''
      }
      this.ruleFormTime = {
        modelTimeAttributeValueConfigId: this.ruleFormTime.modelTimeAttributeValueConfigId,
        name: this.ruleFormTime.name,
        decisionId: '',
        endTime: '',
        orderNum: '',
        startTime: '',
        type: '',
        weekTime: '',
        time: '',
        id: ''
      }
      this.extendIsDialog = false
      this.extendIsDialog_ = false
    },
    openAddit_() {
      this.addEditId = ''
      this.ruleFormTime = {
        modelTimeAttributeValueConfigId: this.ruleFormTime.modelTimeAttributeValueConfigId,
        name: this.ruleFormTime.name,
        endTime: '',
        orderNum: '',
        startTime: '',
        weekTime: '',
        id: '',
        time: ''
      }
      this.extendIsDialog_ = true
    },
    getGrowthModelTimeAttributeValueConfigTask(val) {
      this.$api.growthModel.getGrowthModelTimeAttributeValueConfigTask({ id: val }).then(res => {
        if (res.code == 200) {
          res.data.time = [res.data.startTime, res.data.endTime]
          res.data.modelTimeAttributeValueConfigId = this.ruleFormTime.modelTimeAttributeValueConfigId
          res.data.name = this.ruleFormTime.name
          this.ruleFormTime = res.data
        }
      })
    },
    getGrowthModelTimeAttributeValueConfigTaskList() {
      this.$api.growthModel.getGrowthModelTimeAttributeValueConfigTaskList({ id: this.ruleFormTime.modelTimeAttributeValueConfigId, pageNum: 1, pageSize: 200 }).then(res => {
        if (res.code == 200) {
          this.tableData_ = res.data
        }
      })
    },
    openAddit(val) {
      this.timeId = val
      console.log(val)
      this.ruleFormTime.modelTimeAttributeValueConfigId = val.id
      this.ruleFormTime.name = val.growthModelAttributeName
      this.timedTaskDialog = true
      this.getGrowthModelTimeAttributeValueConfigTaskList()

      // this.getGrowthModelDecisionSchedules()
    },
    handleCancelExtend1() {
      this.timedTaskDialog = false
    },
    handleClick(e, index) {
      console.log(e, index)
      this.getGrowthModelTimeAttributeValueConfigList(e.name, index, e._data.index)
      // console.log(tab.name, tab._data, event)
    },
    // 获取生长模型数据
    getGrowthModelData() {
      // 清空数据
      this.tableDataList = []
      // 获取数据
      this.$api.growthModel.getNewGrowthModelDetailByEncryption({ modelId: this.growthModelId }).then(res => {
        if (res.code == 200) {
          // 解密并转JSON对象
          let data = JSON.parse(this.$aes.decryptEcb(res.data.data))
          this.tableDataList = data.stageList
          this.tableDataList.map((item, index) => {
            item.timeList.map(async (citem, cindex) => {
              console.log(item.timeList[0], 6689)
              citem.activeName_ = item.timeList[0].dataList[0].modelTimeAttributeValueId
              this.getGrowthModelTimeAttributeValueConfigList(item.timeList[0].timeId, index)
              // citem.tableDate_ = this.tableDate_
            })
          })

          setTimeout(() => {
            this.showRule = true
          }, 1000)
        }
      })
    },
    delGrowthModelTimeAttributeValueConfigTask(id) {
      this.$api.system.delfun(`/pc/GrowthModelTimeAttributeValueConfigTask/delGrowthModelTimeAttributeValueConfigTask`, id).then(res => {
        if (res.code == 200) {
          this.getGrowthModelTimeAttributeValueConfigTaskList()
        }
      })
    },
    handleDelData_(id) {
      this.$api.system.delfun(`/pc/growthModelTimeAttributeValueConfig/delGrowthModelTimeAttributeValueConfig`, id).then(res => {
        if (res.code == 200) {
          this.getGrowthModelData()
        }
      })
    },
    getGrowthModelTimeAttributeValueConfigList(val, index) {
      console.log(val, 67)
      this.$api.growthModel.getGrowthModelTimeAttributeValueConfigList({ id: val, pageNum: 1, pageSize: 200 }).then(res => {
        if (res.code == 200) {
          this.tableDataList[index].timeList[0].tableData_ = res.data
          this.timeShow = true
          this.$forceUpdate()
          // this.tableList = this.tableDataList
          console.log(this.tableDataList, 669)
        }
      })
    },
    // 添加生长阶段
    handleAddStage() {
      this.stageForm.name = ''
      this.stageForm.image = ''
      this.addEditStageIndex = this.tableDataList.length
      this.addEditStageTitle = '添加生长阶段'
      this.addEditStageIsDialog = true
    },
    // 编辑生长阶段
    handleEditStage(index) {
      this.stageForm.name = this.tableDataList[index].stageName
      this.stageForm.image = this.tableDataList[index].image
      this.addEditStageIndex = index
      this.addEditStageTitle = '编辑生长阶段'
      this.addEditStageIsDialog = true
    },
    // 删除生长阶段
    handleDelStage(index) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.tableDataList.splice(index, 1)
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 保存生长阶段
    handleSaveStage() {
      this.$refs['stageForm'].validate(valid => {
        if (valid) {
          if (this.addEditStageIndex >= this.tableDataList.length) {
            // 新增
            this.tableDataList.push({
              image: this.stageForm.image,
              stageName: this.stageForm.name,
              stageTimeTab: 0,
              timeList: []
            })
            this.addEditTimeIndex = 0
          } else {
            // 编辑
            this.tableDataList[this.addEditStageIndex].stageName = this.stageForm.name
            this.tableDataList[this.addEditStageIndex].image = this.stageForm.image
          }
          console.log(this.tableDataList, '223')
          // 关闭生长阶段弹窗
          this.handleCloseStage()
        }
      })
    },
    // 关闭生长阶段弹窗
    handleCloseStage() {
      this.addEditStageIsDialog = false
    },
    // 添加生长时间
    handleAddTime(index) {
      this.timeForm.name = ''
      this.timeForm.cycleTime = ''
      this.timeForm.orderNum = ''
      this.timeForm.planIdArr = []
      this.timeForm.planIds = ''
      this.addEditStageIndex = index
      this.addEditTimeIndex = this.tableDataList[index].timeList.length
      this.addEditTimeTitle = '添加细分阶段'
      this.addEditTimeIsDialog = true
    },
    // 编辑生长阶段
    handleEditTime(index) {
      // 获取当前生长阶段的选中的时间Tab
      let tab = this.tableDataList[index].stageTimeTab

      this.timeForm.name = this.tableDataList[index].timeList[tab].timeName
      this.timeForm.cycleTime = this.tableDataList[index].timeList[tab].cycleTime
      this.timeForm.orderNum = this.tableDataList[index].timeList[tab].orderNum
      this.timeForm.planIds = this.tableDataList[index].timeList[tab].planIds
      this.timeForm.planIdArr = this.tableDataList[index].timeList[tab].planIds != undefined ? this.tableDataList[index].timeList[tab].planIds.split(',') : []
      this.addEditStageIndex = index
      this.addEditTimeIndex = this.tableDataList[index].stageTimeTab
      this.addEditTimeTitle = '编辑生长时间'
      this.addEditTimeIsDialog = true
    },
    // 删除生长时间
    handleDelTime(index) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 获取当前生长阶段的选中的时间Tab
          let tab = this.tableDataList[index].stageTimeTab

          // 删除当前选中的时间Tab
          this.tableDataList[index].timeList.splice(tab, 1)
          // 重置选中的时间tab为第一个，没有的话，重置成-1
          this.tableDataList[index].stageTimeTab = this.tableDataList[index].timeList.length > 0 ? 0 : -1
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 保存生长时间
    handleSaveTime() {
      this.$refs['timeForm'].validate(valid => {
        if (valid) {
          let index = this.addEditStageIndex
          let index2 = this.addEditTimeIndex
          if (this.addEditTimeIndex >= this.tableDataList[index].timeList.length) {
            // 新增
            // 默认取第一个的字段
            let timeAttributes = []
            if (this.tableDataList.length > 0 && this.tableDataList[0].timeList.length > 0) {
              this.tableDataList[0].timeList[0].timeAttributes.forEach(val => {
                timeAttributes.push({
                  growthModelAttributeId: val.growthModelAttributeId,
                  growthModelAttributeName: val.growthModelAttributeName,
                  growthModelAttributeUnit: val.growthModelAttributeUnit,
                  difEnd: val.difEnd,
                  difStart: val.difStart,
                  orderNum: val.orderNum,
                  id: ''
                })
              })
            }

            // 字段数据
            let attributeValues = []
            timeAttributes.forEach(val => {
              attributeValues.push({
                growthModelAttributeId: '',
                modelTimeAttributeId: '',
                minValue: undefined,
                maxValue: undefined,
                id: ''
              })
            })

            this.tableDataList[index].timeList.push({
              timeName: this.timeForm.name,
              cycleTime: this.timeForm.cycleTime,
              orderNum: this.timeForm.orderNum,
              planIds: this.timeForm.planIdArr.toString(),
              planIdArr: this.timeForm.planIdArr,
              dataList: [
                {
                  startTime: '',
                  endTime: '',
                  time: ['', ''],
                  attributeValues: attributeValues
                }
              ],
              timeAttributes: timeAttributes
            })

            // 默认选中添加的生长时间Tab
            this.tableDataList[index].stageTimeTab = this.tableDataList[index].timeList.length - 1
          } else {
            // 编辑
            this.tableDataList[index].timeList[index2].timeName = this.timeForm.name
            this.tableDataList[index].timeList[index2].cycleTime = this.timeForm.cycleTime
            this.tableDataList[index].timeList[index2].orderNum = this.timeForm.orderNum
            this.tableDataList[index].timeList[index2].planIds = this.timeForm.planIdArr.toString()
            this.tableDataList[index].timeList[index2].planIdArr = this.timeForm.planIdArr
          }

          // 关闭生长时间弹窗
          this.handleCloseTime()
        }
      })
    },
    // 关闭生长时间弹窗
    handleCloseTime() {
      this.addEditTimeIsDialog = false
    },
    // 添加环境字段
    handleAddColumn(index, i) {
      console.log(i)
      if (i) {
        this.columnForm.growthModelAttributeId = i.growthModelAttributeId
        this.columnForm.difEnd = i.difEnd
        this.columnForm.difStart = i.difStart
      }
      this.addEditColumnTitle = '添加环境参数'
      this.addEditColumnIndex = index
      this.addEditColumnIsDialog = true
    },
    // 添加环境字段
    handleAddColumn_(index, i) {
      console.log(i, 669)
      this.addEditColumnTitle = '添加环境参数'
      this.columnForm.id = ''
      this.columnForm.modelTimeAttributeValueId = index
      this.columnForm.growthModelTimeId = i.timeId
      this.addEditColumnIsDialog_ = true
    },
    getGrowthModelTimeAttributeValueConfig(id) {
      this.$api.growthModel.getGrowthModelTimeAttributeValueConfig({ id: id.row.id }).then(res => {
        if (res.code == 200) {
          this.columnForm = res.data
          this.addEditColumnTitle = '编辑环境参数'
          this.addEditColumnIsDialog_ = true
        }
      })
    },
    handleSaveColumn_() {
      this.columnForm.taskWeight = 100 - this.columnForm.weight
      this.$api.growthModel.saveGrowthModelTimeAttributeValueConfig(this.columnForm).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getGrowthModelData()
          this.handleCloseColumn_()
        }
      })
    },
    // 关闭环境字段
    handleCloseColumn_() {
      this.columnForm.growthModelAttributeId = undefined
      this.columnForm.bias = undefined
      this.columnForm.difEnd = undefined
      this.columnForm.difStart = undefined
      this.columnForm.lowerValue = undefined
      this.columnForm.upValue = undefined
      this.columnForm.weight = undefined
      this.columnForm.intervalDay = undefined
      this.addEditColumnIsDialog_ = false
    },
    // 关闭环境字段
    handleCloseColumn() {
      this.columnForm.growthModelAttributeId = undefined
      this.columnForm.difEnd = undefined
      this.columnForm.difStart = undefined
      this.addEditColumnIsDialog = false
    },

    // 保存环境字段
    handleSaveColumn() {
      this.$refs['columnForm'].validate(valid => {
        if (valid) {
          var this_ = this
          // 获取当前生长阶段的选中的时间Tab
          let tab = this.tableDataList[this.addEditColumnIndex].stageTimeTab
          // 生长模型字段属性id
          let growthModelAttributeId = this.columnForm.growthModelAttributeId

          // 生长模型字段属性
          let growthModelAttribute = this.growthModelAttributeArray.find(function (e) {
            return e.id == growthModelAttributeId
          })

          // 检测是否存在该字段，字段不能重复添加
          let timeAttribute = this.tableDataList[this.addEditColumnIndex].timeList[tab].timeAttributes.find(function (e) {
            if (e.growthModelAttributeId == growthModelAttributeId) {
              e.difStart = this_.columnForm.difStart
              e.difEnd = this_.columnForm.difEnd
              return e
            }
          })
          console.log(timeAttribute, 233)
          if (timeAttribute && timeAttribute != null) {
            // this.$message.error('字段不能重复添加')
            this.handleCloseColumn()
            return
          }

          // 在当前时间tab下的环境字段排序号
          let orderNum = this.tableDataList[this.addEditColumnIndex].timeList[tab].timeAttributes.length
          // 在当前时间tab下添加环境字段
          this.tableDataList[this.addEditColumnIndex].timeList[tab].timeAttributes.push({
            growthModelAttributeId: growthModelAttributeId,
            growthModelAttributeName: growthModelAttribute.name,
            growthModelAttributeUnit: growthModelAttribute.unit,
            difStart: this.columnForm.difStart,
            difEnd: this.columnForm.difEnd,
            orderNum: orderNum,
            id: ''
          })

          // 在当前时间tab下添加环境字段数据
          this.tableDataList[this.addEditColumnIndex].timeList[tab].dataList.forEach(val => {
            val.attributeValues.push({
              growthModelAttributeId: growthModelAttributeId,
              modelTimeAttributeId: '',
              minValue: undefined,
              maxValue: undefined,
              id: ''
            })
          })

          // 关闭环境字段
          this.handleCloseColumn()
        }
      })
    },
    // 删除环境字段
    handleDelColumn(stageIndex, timeIndex, columnIndex) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 在当前时间tab下删除环境字段
          this.tableDataList[stageIndex].timeList[timeIndex].timeAttributes.splice(columnIndex, 1)

          // 重置排序号
          let length = this.tableDataList[stageIndex].timeList[timeIndex].timeAttributes.length
          for (let i = 0; i < length; i++) {
            this.tableDataList[stageIndex].timeList[timeIndex].timeAttributes[i].orderNum = i
          }

          // 在当前时间tab下删除环境字段数据
          this.tableDataList[stageIndex].timeList[timeIndex].dataList.forEach(val => {
            val.attributeValues.splice(columnIndex, 1)
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 左移环境字段
    handleMoveLeftColumn(stageIndex, timeIndex, columnIndex) {
      if (columnIndex <= 0) {
        return
      }

      // 在当前时间tab下左移环境字段
      let timeAttributes = this.tableDataList[stageIndex].timeList[timeIndex].timeAttributes
        ;[timeAttributes[columnIndex - 1], timeAttributes[columnIndex]] = [timeAttributes[columnIndex], timeAttributes[columnIndex - 1]]

      timeAttributes[columnIndex - 1].orderNum = columnIndex - 1
      timeAttributes[columnIndex].orderNum = columnIndex

      this.$set(this.tableDataList[stageIndex].timeList[timeIndex], 'timeAttributes', timeAttributes)

      // 在当前时间tab下左移环境字段数据
      let dataList = this.tableDataList[stageIndex].timeList[timeIndex].dataList
      dataList.forEach(val => {
        ;[val.attributeValues[columnIndex - 1], val.attributeValues[columnIndex]] = [val.attributeValues[columnIndex], val.attributeValues[columnIndex - 1]]
      })
      this.$set(this.tableDataList[stageIndex].timeList[timeIndex], 'dataList', dataList)

      this.$forceUpdate()
    },
    // 右移环境字段
    handleMoveRightColumn(stageIndex, timeIndex, columnIndex) {
      if (columnIndex >= this.tableDataList[stageIndex].timeList[timeIndex].timeAttributes.length - 1) {
        return
      }

      // 在当前时间tab下左移环境字段
      let timeAttributes = this.tableDataList[stageIndex].timeList[timeIndex].timeAttributes
        ;[timeAttributes[columnIndex + 1], timeAttributes[columnIndex]] = [timeAttributes[columnIndex], timeAttributes[columnIndex + 1]]

      timeAttributes[columnIndex + 1].orderNum = columnIndex + 1
      timeAttributes[columnIndex].orderNum = columnIndex
      this.$set(this.tableDataList[stageIndex].timeList[timeIndex], 'timeAttributes', timeAttributes)

      // 在当前时间tab下左移环境字段数据
      let dataList = this.tableDataList[stageIndex].timeList[timeIndex].dataList
      dataList.forEach(val => {
        ;[val.attributeValues[columnIndex + 1], val.attributeValues[columnIndex]] = [val.attributeValues[columnIndex], val.attributeValues[columnIndex + 1]]
      })
      this.$set(this.tableDataList[stageIndex].timeList[timeIndex], 'dataList', dataList)

      this.$forceUpdate()
    },
    // 时间段改变事件
    timeChange(stageIndex, timeIndex, dataIndex) {
      // 时间数据
      let dataList = this.tableDataList[stageIndex].timeList[timeIndex].dataList

      // 当前时间
      let time = dataList[dataIndex].time
      if (!time || time.length == 0 || time[0] == '' || time[1] == '') {
        return
      }

      // 遍历检查是否重叠
      let length = dataList.length
      for (let i = 0; i < length; i++) {
        // 过滤当前时间
        if (i == dataIndex) {
          continue
        }

        // 检查是否重叠
        if (this.timeIsOverlap(time, dataList[i].time)) {
          // 重置为空
          this.tableDataList[stageIndex].timeList[timeIndex].dataList[dataIndex].time = ['', '']
          this.$message.error('时间段不能重叠')
          return
        }
      }
    },
    // 检查是否重叠
    timeIsOverlap(time1, time2) {
      if (!time1 || time1.length == 0 || time1[0] == '' || time1[1] == '') {
        return
      }

      if (!time2 || time2.length == 0 || time2[0] == '' || time2[1] == '') {
        return false
      }

      let startTime1 = this.timeToMinute(time1[0])
      let endTime1 = this.timeToMinute(time1[1])

      let startTime2 = this.timeToMinute(time2[0])
      let endTime2 = this.timeToMinute(time2[1])

      // 结束时间1小于开始时间2，则表示不重叠
      let isOverlap1 = endTime1 < startTime2

      // 结束时间2小于开始时间1，则表示不重叠
      let isOverlap2 = endTime2 < startTime1

      return !isOverlap1 && !isOverlap2
    },
    // 时间转化分钟
    timeToMinute(time) {
      let timeArr = time.split(':')
      return Number(timeArr[0]) * 60 + Number(timeArr[1])
    },
    // 添加环境参数
    handleAddData(index) {
      // 获取当前生长阶段的选中的时间Tab
      let tab = this.tableDataList[index].stageTimeTab

      // 在当前时间tab下添加环境字段
      let attributeValues = []
      this.tableDataList[index].timeList[tab].timeAttributes.forEach(val => {
        attributeValues.push({
          growthModelAttributeId: val.growthModelAttributeId,
          modelTimeAttributeId: '',
          minValue: undefined,
          maxValue: undefined,
          id: ''
        })
      })

      // 在当前时间tab下添加环境参数
      this.tableDataList[index].timeList[tab].dataList.push({
        startTime: '',
        endTime: '',
        time: ['', ''],
        attributeValues: attributeValues
      })
    },
    // 删除环境参数
    handleDelData(index, scope) {
      // 获取当前生长阶段的选中的时间Tab
      let tab = this.tableDataList[index].stageTimeTab

      // 在当前时间tab下删除环境参数
      this.tableDataList[index].timeList[tab].dataList.splice(scope.$index, 1)
    },
    // 查看环境参数
    handleSeeData(index, index2) {
      // 更新当前阶段下的选中的时间tab
      this.tableDataList[index].stageTimeTab = index2

      this.getGrowthModelTimeAttributeValueConfigList(this.tableDataList[index].timeList[index2].timeId, index)
    },
    // 保存生长模型
    handleSave() {
      if (this.tableDataList.length == 0) {
        this.$message.error('至少添加一个生长阶段')
        return
      }

      // 时间段不能为空
      let flag = true
      this.tableDataList.forEach(val => {
        if (!flag) {
          return
        }

        if (val.timeList) {
          val.timeList.forEach(val2 => {
            if (!flag) {
              return
            }

            if (val2.dataList) {
              val2.dataList.forEach(val3 => {
                if (!val3.time || val3.time.length == 0 || val3.time[0] == '' || val3.time[1] == '') {
                  flag = false
                  this.$message.error(val.stageName + '-' + val2.timeName + '中参数时间段不能为空')
                  return
                }

                val3.startTime = val3.time[0]
                val3.endTime = val3.time[1]

                // 遍历字段数据，数据全部必填
                if (val3.attributeValues) {
                  val3.attributeValues.forEach(val4 => {
                    if (!flag) {
                      return
                    }

                    if (val4.minValue == undefined || val4.minValue === '' || val4.maxValue == undefined || val4.maxValue === '') {
                      flag = false
                      this.$message.error(val.stageName + '-' + val2.timeName + '中参数数据不能为空')
                      return
                    }
                  })
                }
              })
            }
          })
        }
      })

      if (!flag) {
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '生长模型保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      console.log(this.tableDataList, 587)
      // 转JOSN字符串，并加密
      let data = this.$aes.encryptEcb(
        JSON.stringify({
          modelId: this.growthModelId,
          stageList: this.tableDataList
        })
      )

      // 保存数据
      this.$api.growthModel.saveNewGrowthModelDetailBydecryption({ data: data }).then(res => {
        loading.close()
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          // 获取生长模型数据
          this.getGrowthModelData()
        }
      })
    },
    // 模板下载
    setExport() {
      window.location.href = 'http://192.168.1.112:8080/intelligent_agriculture_webservice/static/excel/樱桃萝卜.xls'
    },
    // 导出生长模型
    handleExport() {
      this.$api.growthModel.exportGrowthModelData({ id: this.growthModelId }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          window.location.href = res.data
        }
      })
    },
    // 导入
    handleImport() {
      this.$confirm('导入会替换原生长模型，是否继续导入？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.importDialog = true
        })
        .catch(() => {
          this.$message.info('已取消导入')
        })
    },
    // 关闭导入弹窗
    handleCloseImport() {
      this.importDialog = false
      this.getGrowthModelData()
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.msg
        })
        // 重新获取生长模型数据
        this.getGrowthModelData()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 上传Excel
    handleChange(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式！',
          type: 'warning'
        })
      }
      return extension || extension2
    },
    // 返回
    handleReturn() {
      console.log(this.showRule, 669)
      if (this.showRule) {
        this.$router.push({
          name: `growthModel`,
          query: { activeName: 'first' }
        })
      } else {
        this.$message({
          type: 'error',
          message: '请先保存内容再返回'
        })
      }
    },
    // 获取光合作用列表
    getPlanAll() {
      this.$api.photosynthesis.getPlanAll().then(res => {
        if (res.code == 200) {
          this.planArray = res.data
        }
      })
    },
    // 获取生长模型字段属性列表
    getGrowthModelAttributeList() {
      this.$api.growthModel.getGrowthModelAttributes({}).then(res => {
        if (res.code == 200) {
          this.growthModelAttributeArray = res.data
        }
      })
    },
    // 处理字段属性
    dealAttribute(name, unit) {
      if (!unit || unit == '') {
        return name
      } else {
        return name + '（' + unit + '）'
      }
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.$forceUpdate()
        this.stageForm.image = res.data
        this.$toaster.ok(res.msg)
      }
    },
    // 上传之前检测
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isSize = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 、PNG 格式!')
      }
      if (!isSize) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isSize
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/growthStageManagement.scss';

li {
  padding-left: 15px;
}
::deep .el-tabs__item {
  width: 200px !important;
}
.a23 {
  display: flex;
  justify-content: space-between;
}
</style>
